/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-misc-bill-item.reducer';

export const PharmacyMiscBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const pharmacyMiscBillItemEntity = useAppSelector(state => state.pharmacyMiscBillItem.entity);
  const loading = useAppSelector(state => state.pharmacyMiscBillItem.loading);
  const updating = useAppSelector(state => state.pharmacyMiscBillItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyMiscBillItem.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-misc-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyBills({}));
    dispatch(getPaymentSchemes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.chargedMrp !== undefined && typeof values.chargedMrp !== 'number') {
      values.chargedMrp = Number(values.chargedMrp);
    }
    if (values.qty !== undefined && typeof values.qty !== 'number') {
      values.qty = Number(values.qty);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.gst !== undefined && typeof values.gst !== 'number') {
      values.gst = Number(values.gst);
    }

    const entity = {
      ...pharmacyMiscBillItemEntity,
      ...values,
      pharmacyBill: pharmacyBills.find(it => it.id.toString() === values.pharmacyBill?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyMiscBillItemEntity,
          pharmacyBill: pharmacyMiscBillItemEntity?.pharmacyBill?.id,
          scheme: pharmacyMiscBillItemEntity?.scheme?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyMiscBillItem.home.createOrEditLabel" data-cy="PharmacyMiscBillItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyMiscBillItem.home.createOrEditLabel">
              Create or edit a PharmacyMiscBillItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-misc-bill-item-id"
                  label={translate('tinyMedicRestApp.pharmacyMiscBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.chargedMrp')}
                id="pharmacy-misc-bill-item-chargedMrp"
                name="chargedMrp"
                data-cy="chargedMrp"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.qty')}
                id="pharmacy-misc-bill-item-qty"
                name="qty"
                data-cy="qty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.active')}
                id="pharmacy-misc-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.cursor')}
                id="pharmacy-misc-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.timestampentry')}
                id="pharmacy-misc-bill-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.microSec')}
                id="pharmacy-misc-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.lastupdated')}
                id="pharmacy-misc-bill-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.paidAmount')}
                id="pharmacy-misc-bill-item-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.gst')}
                id="pharmacy-misc-bill-item-gst"
                name="gst"
                data-cy="gst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.chargeName')}
                id="pharmacy-misc-bill-item-chargeName"
                name="chargeName"
                data-cy="chargeName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                id="pharmacy-misc-bill-item-pharmacyBill"
                name="pharmacyBill"
                data-cy="pharmacyBill"
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.pharmacyBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-misc-bill-item-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.pharmacyMiscBillItem.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-misc-bill-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyMiscBillItemUpdate;
